import { defaultGUIDValue } from './constants'

export function updateAssigneeIdsNullValue(assigneeIds: string[] | undefined) {
  if (!assigneeIds) return []
  const nullIndex = assigneeIds.indexOf('null')
  const defaultGuidIndex = assigneeIds.indexOf(defaultGUIDValue)
  const assigneeIdsUpdated = [...assigneeIds]
  if (nullIndex != -1) assigneeIdsUpdated[nullIndex] = defaultGUIDValue
  else {
    if (defaultGuidIndex != -1) assigneeIdsUpdated[defaultGuidIndex] = 'null'
  }
  return assigneeIdsUpdated
}
